import React, { Suspense, useEffect, useState } from "react";
import NavBar from "../../Components/Navbar/NavBar";
import {
  Grid,
  Flex,
  Box,
  Text,
  Button,
  Card,
  Input,
  Select,
  Skeleton,
  Spinner,
  useToast,
} from "@chakra-ui/react";
import DataTable from "react-data-table-component";
import axios from "axios";
import UpdateAccessModal from "./UpdateAccessModal";
import NewUserModal from "./NewUserModal";
import DeactivateUserModal from "./DeactivateUserModal";
import ResetPasswordModal from "./ResetPasswordModal";
const options = [
  { value: "admin", label: "Admin" },
  { value: "manager", label: "Manager" },
  { value: "user", label: "User" },
  { value: "store", label: "Store" },
  { value: "deactivated", label: "Deactivated" },
];

const UserManagement = ({ currentUserId }) => {
  const toast = useToast();
  const [users, setUsers] = useState([]);
  const [filteredUser, setFiltereUser] = useState();
  const [pageLoading, setPageLoading] = useState(false);
  const [selectedUser, setSelectedUser] = useState({
    selectedUser: "",
    selectedUserId: "",
    selectedUserAcces: [],
  });
  const [newUserModal, setNewUserModal] = useState(false);
  const [removeUserModal, setRemoveUserModal] = useState(false);
  const [trigger, setTrigger] = useState(false);
  const [modalOpen, setModalOpen] = useState(false);
  const [isSubmittingRole, setisSubmittingRole] = useState(false);
  const [resetPasswordModal, setResetPasswordModal] = useState(false);
  const [departmentFilter, setDepartmentFilter] = useState("");
  const [resetPage, setResetPage] = useState(false);

  const departments = [...new Set(users.map((u) => u.department).filter(Boolean))].sort();
  useEffect(() => {
    const fetchData = async () => {
      setPageLoading(true);
      const res = await axios.get(
        `${process.env.REACT_APP_BACKEND_API_URL}/getAlluser`,
        { withCredentials: true }
      );
      setUsers(res.data);
      setPageLoading(false);
    };
    fetchData();
  }, [trigger]);
  const applyFilters = (searchVal, deptVal) => {
    const filtered = users.filter((user) => {
      const matchesSearch =
        !searchVal ||
        user.username?.toLowerCase().includes(searchVal) ||
        user.role?.toLowerCase().includes(searchVal);
      const matchesDept =
        !deptVal || user.department?.toLowerCase() === deptVal.toLowerCase();
      return matchesSearch && matchesDept;
    });
    setFiltereUser(filtered);
  };

  const handleSearchUser = (e) => {
    const searchVal = e.target.value.toLowerCase();
    applyFilters(searchVal, departmentFilter);
    setResetPage((prev) => !prev);
  };

  const handleDepartmentFilter = (e) => {
    const deptVal = e.target.value;
    setDepartmentFilter(deptVal);
    applyFilters("", deptVal);
    setResetPage((prev) => !prev);
  };
  const handleUpdateAccess = (row) => {
    setSelectedUser({
      selectedUser: row.username,
      selectedUserId: row.idlogin,
      selectedUserAcces: row.access,
      selectedUserStore: row.storename,
    });
  };
  const modalState = () => {
    setModalOpen((prev) => !prev);
  };
  const handleUpdateRole = (val, id) => {
    setisSubmittingRole(true);
    try {
      axios.post(
        `${process.env.REACT_APP_BACKEND_API_URL}/updateUserRole`,
        {
          id: id,
          role: val,
        },
        { withCredentials: true }
      );
      toast({
        title: "Success",
        position: "top-right",
        description: "You successfully updated the user Role.",
        status: "success",
        duration: 9000,
        isClosable: true,
      });
      setisSubmittingRole(false);
      setTrigger((prev) => !prev);
    } catch (err) {
      toast({
        title: "Error",
        position: "top-right",
        description: err.response.data.message,
        status: "error",
        duration: 9000,
        isClosable: true,
      });
      setisSubmittingRole(false);
    }
  };
  const newUserModalOpen = () => {
    setNewUserModal(true);
  };
  const newUserModalClose = () => {
    setTrigger((prev) => !prev);
    setNewUserModal(false);
  };
  const removeModalState = () => {
    setRemoveUserModal((prev) => !prev);
  };
  const resetPasswordModalState = () => {
    setResetPasswordModal((prev) => !prev);
  };
  return (
    <Box height={"100vh"}>
      <NavBar inManagement />
      <Card mx={6} mt={6}>
        <Box mx={6}>
          <Box
            mt={5}
            display={"flex"}
            flexDirection={{ base: "column", md: "row" }}
            justifyContent={"space-between"}
            mb={7}
          >
            <Text fontSize={"3xl"} fontWeight={"bold"}>
              User Management
            </Text>
            <Box
              display={"flex"}
              flexDirection={{ base: "column", md: "row" }}
              justifyContent={"space-evenly"}
              mt={{ base: 5, md: 0 }}
            >
              <Button
                onClick={newUserModalOpen}
                bg={"green"}
                textColor={"white"}
                isDisabled={pageLoading}
                mb={{ base: 2, md: 0 }}
                mr={{ base: 2, md: 5 }}
                _hover={{ bg: "darkgreen" }}
              >
                {pageLoading ? <Spinner /> : "New User"}
              </Button>
              <Button
                onClick={removeModalState}
                bg={"tomato"}
                textColor={"white"}
                isDisabled={pageLoading}
                mb={{ base: 2, md: 0 }}
                mr={{ base: 2, md: 5 }}
                _hover={{ bg: "darkred" }}
              >
                {pageLoading ? <Spinner /> : "Deactivate User"}
              </Button>
              <Button
                onClick={resetPasswordModalState}
                bg={"blue"}
                textColor={"white"}
                isDisabled={pageLoading}
                _hover={{ bg: "darkblue" }}
              >
                {pageLoading ? <Spinner /> : "Reset Password"}
              </Button>
            </Box>
          </Box>
          <Box display={"flex"} flexDirection={{ base: "column", md: "row" }} gap={3} mb={5}>
            <Input
              placeholder="Search User"
              onChange={handleSearchUser}
              isDisabled={pageLoading}
            />
            <Select
              placeholder="All Departments"
              onChange={handleDepartmentFilter}
              value={departmentFilter}
              isDisabled={pageLoading}
              maxW={{ md: "250px" }}
            >
              {departments.map((dept) => (
                <option key={dept} value={dept}>
                  {dept}
                </option>
              ))}
            </Select>
          </Box>
          <Skeleton isLoaded={!pageLoading}>
            <DataTable
              columns={[
                {
                  name: (
                    <div style={{ fontSize: 15, fontWeight: "bold" }}>ID</div>
                  ),
                  selector: (row) => row.idlogin,
                  sortable: true,
                  filterable: true,
                },
                {
                  name: (
                    <div style={{ fontSize: 15, fontWeight: "bold" }}>Name</div>
                  ),
                  selector: (row) => row.username,
                  sortable: true,
                  filterable: true,
                },

                {
                  name: (
                    <div style={{ fontSize: 15, fontWeight: "bold" }}>Role</div>
                  ),
                  selector: (row) => row.role,
                  sortable: true,
                  filterable: true,
                },
                {
                  name: (
                    <div style={{ fontSize: 15, fontWeight: "bold" }}>
                      Department
                    </div>
                  ),
                  selector: (row) => row.department,
                  sortable: true,
                  filterable: true,
                },
                {
                  name: (
                    <div style={{ fontSize: 15, fontWeight: "bold" }}>
                      Assigned Stores
                    </div>
                  ),
                  selector: (row) => {
                    if (!row.storename || row.storename.length === 0) return "N/A";
                    return Array.isArray(row.storename) 
                      ? row.storename.join(", ") 
                      : row.storename;
                  },
                  sortable: true,
                  filterable: true,
                },
                {
                  name: (
                    <div style={{ fontSize: 15, fontWeight: "bold" }}>
                      Access
                    </div>
                  ),
                  selector: (row) => (
                    <Text
                      textDecoration="underline"
                      color="blue.500"
                      cursor="pointer"
                      onClick={() => {
                        handleUpdateAccess(row);
                        modalState();
                      }}
                    >
                      {row.access && row.access.length > 0
                        ? row.access.join(", ")
                        : "add access"}
                    </Text>
                  ),
                  sortable: true,
                  filterable: true,
                },
                {
                  name: (
                    <div style={{ fontSize: 15, fontWeight: "bold" }}>
                      Status
                    </div>
                  ),
                  selector: (row) => row.status || "active",
                  sortable: true,
                  filterable: true,
                },
                {
                  name: (
                    <div style={{ fontSize: 15, fontWeight: "bold" }}>
                      User Type
                    </div>
                  ),
                  selector: (row) => row.user_type || "platform",
                  sortable: true,
                  filterable: true,
                },
                {
                  name: (
                    <div style={{ fontSize: 15, fontWeight: "bold" }}>
                      Ownership
                    </div>
                  ),
                  selector: (row) => row.ownership || "N/A",
                  sortable: true,
                  filterable: true,
                },
                {
                  name: (
                    <div style={{ fontSize: 15, fontWeight: "bold" }}>
                      Change Role
                    </div>
                  ),
                  cell: (row) => (
                    <>
                      <Select
                        variant="outline"
                        placeholder="Role"
                        value="option1"
                        isDisabled={
                          currentUserId === row.idlogin || isSubmittingRole
                        }
                        onChange={(e) => {
                          const selectedValue = e.target.value;
                          const id = row.idlogin;
                          handleUpdateRole(selectedValue, id);
                        }}
                      >
                        {options
                          .filter((option) => option.value !== row.role)
                          .map((option) => (
                            <option key={option.value} value={option.value}>
                              {isSubmittingRole ? "Loading..." : option.label}
                            </option>
                          ))}
                      </Select>
                    </>
                  ),
                },
              ]}
              data={filteredUser ? filteredUser : users}
              pagination
              paginationResetDefaultPage={resetPage}
              searchable
              //  customFilterText={customFilterText}
              highlightOnHover
            />
          </Skeleton>
        </Box>
        <UpdateAccessModal
          modalOpen={modalOpen}
          modalClose={modalState}
          user={selectedUser}
          onSuccess={() => setTrigger((prev) => !prev)}
        />
        <NewUserModal
          modalOpen={newUserModal}
          modalClose={newUserModalClose}
          options={options}
          trigger={() => setTrigger((prev) => !prev)}
        />
        <DeactivateUserModal
          modalOpen={removeUserModal}
          modalClose={removeModalState}
          trigger={() => setTrigger((prev) => !prev)}
        />
        <ResetPasswordModal
          modalOpen={resetPasswordModal}
          modalClose={resetPasswordModalState}
        />
      </Card>
    </Box>
  );
};

export default UserManagement;
